module.exports = __webpack_public_path__ + "img/triofundelogo1.95a6dce8.png";